const img1 = require('./l_biodina.png');
const img2 = require('./l_dermoglam.png');
const img3 = require('./l_pro.png');
const img4 = require('./l_retok.png');
const img5 = require('./l_makeup.png');
const img6 = require('./l_skinCare.png');

export const linhas = [img1, img2, img3, img4, img5, img6];
